import React from "react";
import { Card } from "semantic-ui-react";

interface BPProps {
  isGreaterThanMobile?;
  className?;
  leftChildren?:JSX.Element[];
  rightChildren?:JSX.Element[];
}

const addKeytoChild = (children : JSX.Element[], keyName : string) => {
  return children.map((child, index) => React.cloneElement(child, { key: `${keyName}-${index}`}));
};

const BCMenuBar = ({...props}: BPProps) => {
  return (
    <Card fluid className={props.className ? props.className : ""}>
      <div className="landing-page-menu-container">            
        {props.leftChildren && <div className="menubar-left-container">{addKeytoChild(props.leftChildren, "menubar-left-child")}</div>}
        {props.rightChildren && <div className="menubar-right-container">{addKeytoChild(props.rightChildren, "menubar-right-child")}</div>}
      </div>
    </Card>
  );
};

export default BCMenuBar;